export default "__VITE_ASSET__BaYJttjt__"